import { type Event } from '@src/pages/journey-map/types';

import type { SankeyNode } from '@src/pages/journey-map/types';
import type { PathResponse } from '@src/shared/types/user-journeys';
interface SankeyLink {
  source: string;
  target: string;
  value: number;
  flow: number;
  pathId: string;
}

interface SankeyData {
  nodes: SankeyNode[];
  links: SankeyLink[];
}

export function generateSankeyData(
  paths: PathResponse[],
  isEndWith?: boolean,
  isStartWith?: boolean,
): SankeyData {
  const nodes: SankeyNode[] = [];
  const links: SankeyLink[] = [];
  const nodeMap = new Map<string, SankeyNode>();
  // Process each path
  const maxLayer = Math.max(...paths.map((path) => path.user_path?.length || 0));
  paths.forEach((path) => {
    const pathData = [...(path.user_path || [])];

    const pathNodes: any[] = [];

    // fill placeholder to max layer
    // if (isEndWith && isStartWith) {
    //   if (pathData.length !== maxLayer) {
    //     const startEvent = pathData[0];
    //     const postArr = pathData.slice(1);
    //     const fill = [];
    //     for (let i = 0; i < maxLayer - pathData.length; i++) {
    //       fill.push({ ...startEvent, mapped_event_name: startEvent.pathId, prob: 1 });
    //     }
    //     pathData = [startEvent, ...fill, ...postArr];
    //   }
    // }

    pathData.forEach((event, index) => {
      const { flow, pathId, critical_event_name, ce_id } = event;
      let layer = index;
      if (isStartWith && isEndWith) {
        layer = index === pathData.length - 1 ? maxLayer : index;
      } else {
        if (isEndWith) {
          layer = maxLayer - pathData.length + index;
        }
      }
      const nodeId = `${critical_event_name}_${layer}`;
      const node: SankeyNode = {
        id: nodeId,
        ce_id,
        name: event.critical_event_name,
        layer,
        value: path.score || 0,
        pathId,
        flow,
        nwrs: event.nwrs || [],
        duration: event.duration || 0,
        prob: event.prob,
        isHighlighted: event.isMatched || false,
      };

      // for generate link
      pathNodes.push(node);

      // Create node if it doesn't exist
      if (!nodeMap.has(nodeId)) {
        nodes.push(node);
        nodeMap.set(nodeId, node);
      }
    });

    pathNodes.forEach((node, index) => {
      if (index < pathNodes.length - 1) {
        const sourceEvent = node;
        const nextEvent = pathNodes[index + 1];

        links.push({
          source: sourceEvent.id,
          target: nextEvent.id,
          value: nextEvent.value,
          flow: nextEvent.flow,
          pathId: sourceEvent.pathId,
          nwrs: sourceEvent.nwrs || [],
          duration: sourceEvent.duration || 0,
          flow_conversion: nextEvent.flow / sourceEvent.flow,
          prob: nextEvent.prob || 0,
        });
      }
    });
  });

  return {
    nodes,
    links,
  };
}
